import { GoArrowUpRight } from "react-icons/go";
import images from "../../assets/images/Constant";
import homeData from "../../data/home.json";
import { Link } from "react-router-dom";

export default function WhyChooseUs() {

  const whyChoose = homeData?.whyChoose || {};
  const cards = whyChoose?.cards || [];

  return (
    <section className="relative py-16 md:py-24 lg:py-28 flex justify-center items-center min-h-0 lg:min-h-[640px]">

      {/* BACKGROUND */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${images.whybg})` }}
      />
      <div className="absolute inset-0 bg-dark/20"></div>

      <div className="relative max-w-[1200px] mx-auto px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-2 items-center gap-10 lg:gap-8 w-full">

        {/* LEFT CONTENT */}
        <div className="text-white w-full max-w-[634px]">
<div className="flex gap-2 py-4 ">
  <img src={images[whyChoose.icon]} alt=""  className=""/>
          <p className="text-base md:text-[22px] uppercase tracking-widest  text-white">
            {whyChoose.subtitle}
          </p>
</div>
          <h2 className="text-3xl md:text-heading font-semibold leading-tight ">
            {whyChoose.title}
          </h2>

          <p className="mt-4 text-sm md:text-base text-gray-300 max-w-md">
            {whyChoose.description}
          </p>

          <Link to="/contact" className="mt-8 inline-flex text-base md:text-lg justify-center items-center gap-2 bg-secondary text-dark px-5 py-3 rounded font-medium hover:opacity-95 transition">
            Request a Quote
            <GoArrowUpRight />
          </Link>

        </div>

        {/* RIGHT CARDS */}
        <div className="flex gap-3 sm:gap-4 justify-center lg:justify-end flex-wrap">

          {cards.map((card, index) => (
            <div
              key={index}
              className="border border-white/30 p-6 text-center rounded-md backdrop-blur-md bg-dark w-[140px] md:w-[160px]"
            >
              <img
                src={images[card.images]}
                alt=""
                className="mx-auto w-10 h-10"
              />

              <p className="mt-3 text-sm font-medium text-white">
                {card.title}
              </p>
            </div>
          ))}

        </div>
        
      </div>
      
    </section>
  );
}